module.exports = __webpack_public_path__ + "img/vue1-lacet_bleu.c12430c0.png";